/*
 * File: cell-promo-code-validity.ts
 * Created: 2026-01-19 20:10:00
 * Author: Val Liu <valuis0429@gmail.com>
 */

import { Component } from "vue-property-decorator";
import { BaseTableBodyCell } from "@root/components/table/core/lib/base-table-body-cell/base-table-body-cell";

@Component
export default class CellPromoCodeValidity extends BaseTableBodyCell {
    get beginText() {
        return this.formatDate(this.row?.beginAt);
    }

    get endText() {
        return this.formatDate(this.row?.endAt);
    }

    formatDate(value?: string | Date | null) {
        if (!value) return this.$_("w_Unlimited");
        const date = new Date(value);
        if (Number.isNaN(date.getTime())) return this.$_("w_Unlimited");
        return date.toLocaleDateString();
    }
}
